import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let RoutesList = class RoutesList extends Vue {
};
__decorate([
    Prop(Array)
], RoutesList.prototype, "categories", void 0);
RoutesList = __decorate([
    Component
], RoutesList);
export default RoutesList;
